import React, { useEffect, useRef, useState } from 'react';
import UploadFile from '../../../components/Request/UploadFile';
import RefrenceLink from '../../../components/Request/RefrenceLink';
import styles from './Upload3DExistingFile.module.scss';
import cx from 'classnames';
import { REQUEST_3D_FILE_FORMATS } from '../../../constants/constants';
import UploadedFiles from '../../../components/Request/UploadedFiles';
import Tips from '../../../components/Request/Tips';
import Wrapper from './Wrapper';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCurrentPage,
  requestsSelector,
  setCurrentRequestFilesSize,
  setNextButtonEnabled,
  setNextButtonToolTip,
  setRequestData,
} from '../../../redux/slicers/requestSlicer';
import {
  apiDeleteRequestFile,
  apiGetRequestFiles,
  apiGetRequestImages,
  apiPostImageOnPresignedData,
  apiUploadRequestFiles,
} from '../../../helpers/api';
import { getFileFormData, isValidUrl, setDefaultFiles, uploadRequestFile } from './helper';
import UploadFileWrapper from '../../../components/Request/UploadFileWrapper';

function Upload3DExistingFile({ isReadOnly }) {
  const [files, setFiles] = useState([]);
  const [links, setLinks] = useState([{ id: 1, value: '' }]);
  const _requestSelector = useSelector(requestsSelector);
  const dispatch = useDispatch();
  const TIP_TEXT =
    "We accept multiple 3D file formats, but 3ds Max, Maya, Blender, or FBX files are preferred.It's beneficial if the polygons are in quad configuration rather than triangles.\n\nPlease provide a high-quality 3D model file to ensure all details are visible, resulting in more realistic images upon production.";

  const handleFileChange = async (_files) => {
    if (isReadOnly) return;
    const formData = getFileFormData(_files, _requestSelector.currentRequestId, 'productFile');

    uploadRequestFile(formData, _files, files, setFiles, null, false, dispatch, _requestSelector);
  };

  const handleDeleteClick = async (_id) => {
    if (isReadOnly) return;
    const _file = files.find((item) => item.id === _id);
    dispatch(
      setCurrentRequestFilesSize(_requestSelector.currentRequestFilesSize - _file.file.size)
    );

    const _files = files.filter((item) => item.id != _id);
    setFiles(_files);

    await apiDeleteRequestFile(_id);
  };

  useEffect(() => {
    if (isReadOnly) return;
    if (
      files.length
    ) {
      dispatch(setNextButtonEnabled(true));
      dispatch(setNextButtonToolTip(''));
    } else {
      dispatch(setNextButtonEnabled(false));
      dispatch(setNextButtonToolTip('Please upload a file.'));
      // dispatch(setNextButtonToolTip('Please fill in a link or upalod a file.'));
    }
  }, [files]);

  useEffect(async () => {
    if(_requestSelector.currentRequestId) {
      setDefaultFiles(_requestSelector.currentRequestId, 'productFile', setFiles);
      handlefetchLink()
    }
  }, []);

  const handlefetchLink = async () => {
    if(!_requestSelector.currentRequestId) return;
    const _links = await setDefaultFiles(_requestSelector.currentRequestId, 'weblink');
    if (_links.results.length)
      setLinks(
        _links.results.map((_link) => ({
          ..._link,
          value: _link.link?.split('https://')?.at(-1),
          actual_id: _link.id,
        }))
      );
  }

  useEffect(() => {
    return () => dispatch(setNextButtonToolTip(''));
  }, []);

  return (
    <Wrapper
      title={!isReadOnly ? 'Please upload existing 3d model file*' : ''}
      isReadOnly={isReadOnly}>
      <div className={cx('d-flex gap-3', styles.mainWrapper)}>
        <div className={cx(styles.uploadFileWrapper, isReadOnly ? 'w-100' : '')}>
          <RefrenceLink
            title="Web link"
            links={links}
            setLinks={setLinks}
            linkType="weblink"
            isReadOnly={isReadOnly}
            handlefetchLink={handlefetchLink}
          />
          <div className="p-3 bg-white">
            <div
              className={cx('d-grid gap-3', styles.uploadedFilesWrapper)}
              style={
                files.length > 0
                  ? {
                      gridTemplateColumns: 'repeat(auto-fill, minmax(215px, 1fr))',
                    }
                  : {}
              }>
              {!isReadOnly ? (
                <UploadFileWrapper fullWidth={!files.length}>
                  <UploadFile
                    className={
                      !files?.length
                        ? cx(styles.fullWidth, styles.heightFiveHundread)
                        : 'w-100 h-100'
                    }
                    subClassName={'h-100'}
                    title="Drop and Down here"
                    subtitle="or"
                    allowAllFiles={false}
                    allowedFileErrorMessage={`You can only upload Supported file formats:
                        ${REQUEST_3D_FILE_FORMATS?.join(',')}
                      `}
                    allowed_files={REQUEST_3D_FILE_FORMATS}
                    onFileChange={handleFileChange}
                    acceptMutipleFiles={true}
                  />
                </UploadFileWrapper>
              ) : null}
              {files.map(
                (item, index) =>
                  item?.file && (
                    <UploadedFiles
                      key={index}
                      _file={item}
                      onDeleteClick={() => handleDeleteClick(item.id)}
                      variant={2}
                      isReadOnly={isReadOnly}
                    />
                  )
              )}
            </div>
          </div>
        </div>
        {!isReadOnly ? <Tips title="3D files" text={TIP_TEXT} /> : null}
      </div>
    </Wrapper>
  );
}

export default Upload3DExistingFile;
